import Axios, { AxiosResponse } from 'axios';
import { OnboardingFormValues } from 'src/components/Onboarding/OnboardingForms';
import { PortalConfig } from 'src/context';

export default class OnboardingClient {
  static SavePortalOnboarding(
    portalConfig: PortalConfig,
    values: OnboardingFormValues,
  ): Promise<AxiosResponse<any>> {
    const portalApiBaseURL = portalConfig.AWS.API.endpoints[2].endpoint;
    return Axios({
      method: 'post',
      url: `${portalApiBaseURL}/portal/any/setup`,
      data: values,
    });
  }

  static GetPortalSetup(
    portalConfig: PortalConfig,
    stackId: string,
    email: string,
    password: string,
  ): Promise<AxiosResponse<string>> {
    const portalApiBaseURL = portalConfig.AWS.API.endpoints[2].endpoint;
    return Axios({
      method: 'get',
      url: `${portalApiBaseURL}/portal/any/setup`,
      params: {
        stackId,
        email,
        password,
      },
    });
  }

  static GetPortalURLHealth(portalURL: string): Promise<AxiosResponse<string>> {
    return Axios({
      method: 'get',
      url: `${portalURL}/health`,
    });
  }
}
